import { FaGooglePlay } from "react-icons/fa";
import mob_img from "../../../assets/images/mob-banner.png";
import qr_img   from "../../../assets/images/qr-code.png";
import "./PromoBanner.css";

const PromoBanner = () => (
  <section className="promo">
    <div className="promo__container">

      <div className="promo__content">
        <span className="promo__label">Download the app</span>
        <h2 className="promo__title">
          Find Your <em>Perfect</em>
          <br />Property on the Go
        </h2>
        <p className="promo__text">
          Browse stunning homes with modern designs, smart layouts, and
          everything you need to start your next chapter — right from your phone.
        </p>

        <div className="promo__download">
          <a
            href="https://play.google.com/store/apps/details?id=com.AllHomeDesire.AllHomeDesire"
            target="_blank"
            rel="noopener noreferrer"
            className="promo__store-btn"
          >
            <span className="promo__store-btn-icon">
              <FaGooglePlay size={22} color="#ffffff" />
            </span>
            <span className="promo__store-btn-text">
              <span className="promo__store-btn-sub">Get it on</span>
              <span className="promo__store-btn-name">Google Play</span>
            </span>
          </a>

          <div className="promo__qr">
            <img src={qr_img} alt="Scan to download" />
            <span className="promo__qr-label">Scan to Download</span>
          </div>
        </div>
      </div>

      <div className="promo__image-wrap">
        <img src={mob_img} alt="All Home Desire App" className="promo__phone" />
      </div>

    </div>
  </section>
);

export default PromoBanner;